import OverflowInputToolTip from './OverflowInputToolTip';

export default OverflowInputToolTip;
